import React from 'react';
import PropTypes from 'prop-types';

export default function Divider({
  color = 'inherit',
  thickness = '1px',
  margin = '8px 0',
  className = '',
  style = {},
  ...rest
}) {
  const combinedStyle = {
    width: '100%',
    border: 'none',
    borderTop: `${thickness} solid ${color}`,
    margin,
    ...style
  };

  return <hr className={className} style={combinedStyle} {...rest} />;
}

Divider.propTypes = {
  color: PropTypes.string,
  thickness: PropTypes.string,
  margin: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
